// @ts-nocheck

export const TIMER_INCREMENT = 'TIMER_INCR';
export const TIMER_DECREMENT = 'TIMER_DECR';
export const TIMER_STOP = 'TIMER_STOP';
